const scrollToTopButton = document.querySelector('.top-link');

if (scrollToTopButton) {
    const scrollFunc = () => {
        // Get the current scroll value
        const y = window.scrollY;

        // If the scroll value is greater than the window height,
        // let's add a class to the scroll-to-top button to show it!
        if (y > 200) {
            scrollToTopButton.className = 'top-link show';
        } else {
            scrollToTopButton.className = 'top-link hide';
        }
    };
    window.addEventListener('scroll', scrollFunc);
}
